import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { hideReportDialog, reportIssue } from '../actions/test';
import ReportIssueModal from '../components/shared/ReportIssueModal/ReportIssueModal';

const mapStateToProps = state => {
  return {
    test: state.test,
    reportIssueData: state.appStatus.reportIssueData,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      hideReportDialog,
      reportIssue,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportIssueModal);
